import { TromanError } from '@/common/TromanError';
import * as _ from 'lodash';

const regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,}))?(Z|([-+])(\d{2}):(\d{2}))?)?)?)?$/;

export function parseDate(value: any): Date | null {

    if (typeof value === "string") {
        var match = value.match(regexIso8601);
        if (match) {
            var milliseconds = Date.parse(match[0]);
            if (!isNaN(milliseconds)) {
                return new Date(milliseconds);
            }
        }
    }

    return null;
}

export function parseOptionalDate(value: string | null | undefined) {
    if (value) {
        return parseDate(value) || undefined;
    }
}

export function parseRequiredDate(value: string): Date {
    const result = parseDate(value);
    if (result == null) {
        throw new TromanError('parse_missing_required_date');
    }
    return result;
}

const GUID_REGEX = /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/;
export function isGuid(x: any): x is string {
    if (typeof (x) !== 'string')
        return false;
    return GUID_REGEX.test(x);
}

export function isWs(o: any) {
    return typeof o !== 'string' || o.trim() === '';
}

export function compareCalendarDate(a: Date, b: Date) {
    /// <param name="a" type="Date">First value</param>
    /// <param name="b" type="Date">Second value</param>
    var diff = a.getFullYear() - b.getFullYear();
    if (diff !== 0)
        return diff;

    diff = a.getMonth() - b.getMonth();
    if (diff !== 0)
        return diff;

    diff = a.getDate() - b.getDate();
    return diff;
}

export function compare(a: any, b: any) {
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;
    if (a < b) return -1;
    if (b < a) return 1;
    return 0;
}

export function addressToJson(address: any, type: any) {
    if (address == null)
        return;

    if (isWs(address.Address) && isWs(address.ZipCode) && isWs(address.City))
        return;

    address.Type = type != null ? type : address.Type;
    return address;
}

export function phoneToJson(phone: any, type: any) {
    if (phone == null)
        return;

    if (isWs(phone.Number))
        return;

    phone.Type = type != null ? type : phone.Type;
    return phone;
}

export function emailToJson(email: any, type: any) {
    if (email == null)
        return;

    if (isWs(email.Email))
        return;

    email.Type = type != null ? type : email.Type;
    return email;
}

export function urlToJson(url: any, type: any) {
    if (url == null)
        return;

    if (isWs(url.Name) && isWs(url.Url))
        return;

    url.Type = type != null ? type : url.Type;
    return url;
}

export function isNotNull(x: any) {
    return x != null;
}

export function todayDate() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

const ZERO = '0';
function padZero(val: number, digits: number) {
    let ret = '' + val;
    while (ret.length < digits) {
        ret = ZERO + ret;
    }
    return ret;
}

export function formatDate(date: Date) {
    if (!_.isDate(date))
        return '';

    let year = date.getFullYear();
    if (year <= 0) {
        year = -year + 1;
    }

    let ret = padZero(year, 4);
    ret = ret + '-';
    ret = ret + padZero(date.getMonth() + 1, 2);
    ret = ret + '-';
    ret = ret + padZero(date.getDate(), 2);
    return ret;
}

export function isOverlapping(s1: Date, e1: Date, s2: Date, e2: Date) {
    return (e2 == null || s1 <= e2) && (e1 == null || s2 <= e1);
}

export function isValidMunicipality(code: string, codelist: string[]) {
    if (code == null || code === '' || code.length != 4) return false;
    let region = code.substring(0, 2);
    return _.some(codelist, x => x == code || x == region);
}
